import { Component, Input, Output, Inject, EventEmitter } from 'ng-metadata/core';
import './pagination.scss';

/**
 * @ngdoc directive
 * @name mwTablePagination
 * @module mw.components.table
 *
 * @param {number} [items-per-page=25] - The amount of items allowed per page. Should always be 25.
 * @param {number} [page=1] - The current page that the data table should be displaying.
 * @param {number} [item-total=0] - The total amount of items that our data-table has altogether.
 * @param {boolean} [always-visible=false] - Shows pagination even if items-per-page is less than item-total
 * @param {string} [scroll-container-id] - Id of container of which on page change will scroll to the top of that specified container.
 *
 * @param {expression} [on-page-change] - Function that is called when page has changed. $event is an object containing current page and items per page ({page, limit}).
 *
 * @description
 * `<mw-table-pagination>` is a component that handles pagination for our data-table components
 *
 * @usage
 * <hljs hljs-language="html">
 * <!-- Simple Pagination Example -->
 *   <mw-table-pagination md-page-select scroll-container-id="mw-cool-table" items-per-page="$ctrl.paging.itemLimit" page="$ctrl.paging.selectedPage" item-total="$ctrl.paging.total" on-page-change="$ctrl.onPage($event)" md-label="{of: 'of', Page: 'Page:'}" always-visible="$ctrl.alwaysVisible"> </mw-table-pagination>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-table-pagination',
    template: `<md-table-pagination ng-class="{'mw-table-pagination--one-page': $ctrl.itemTotal <= $ctrl.itemsPerPage}" ng-hide="$ctrl.itemTotal <= $ctrl.itemsPerPage && !$ctrl.alwaysVisible" md-page-select scroll-container-id="$ctrl.scrollContainerId" md-limit="$ctrl.itemsPerPage" md-page="$ctrl.page" md-total="{{$ctrl.itemTotal}}" md-on-paginate="$ctrl.onChangePage" md-label="{of: 'of', Page: 'Page:'}"></md-table-pagination>`
})

export class PaginationComponent {

    @Input('<') itemsPerPage: number = 25;
    @Input('<') page: number = 1;
    @Input('<') itemTotal: number = 0;
    @Input('<') alwaysVisible: boolean = false;
    @Input('@') scrollContainerId: string;

    @Output() onPageChange = new EventEmitter<any>();

    constructor(@Inject('$window') private $window: ng.IWindowService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        'ngInject';
    }

    onChangePage: Function = () => {

        // Ugghhh, we need to come up with a better solution to this
        this.$timeout(() => {
            this.onPageChange.emit({page: this.page, limit: this.itemsPerPage});
            this.resetTableScroll(this.scrollContainerId);
        }, 500);
    }

    resetTableScroll(id) {
        let element = this.$window.document.getElementById(id);

        if (element) {
            element.scrollTop = 0;

            // Takes care of bug relating to Safari
            if (element.offsetParent) {
                element.offsetParent.scrollTop = 0;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/table/pagination/pagination.component.ts